import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { tap, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SessionBootstrapService {

  private boot$?: Observable<void>;

  constructor() { }


  load(): Observable<void> {
    if (!this.boot$) {
      this.boot$ = forkJoin({
        /* me: this.me.getMe().pipe(catchError(err => { console.warn('me failed', err); return of(null); })),
        perms: this.perms.load().pipe(catchError(err => { console.warn('perms failed', err); return of(null); })),
        flags: this.flags.load().pipe(catchError(err => { console.warn('flags failed', err); return of(null); })),
        cfg: this.cfg.loadScoped().pipe(catchError(err => of(null))),
        dicts: this.dicts.loadActive().pipe(catchError(err => of(null))), */
      }).pipe(
        tap(res => {
          console.log('Init: Loaded sesion bootsrap service')
          // optional: post-process or normalize
          // e.g., this.perms.set(res.perms) if load() didn't already store
        }),
        map(() => void 0),
        shareReplay(1) // cache within session
      );
    }
    return this.boot$;
  }

}
